import { createEvent } from 'effector'

export const screenOpened = createEvent<string>()
export const userIdentified = createEvent<string>()
export const userPropertiesUpdated = createEvent<Record<string, string>>()
